import { auth } from '@/lib/firebase';
import api from '@/lib/api';

const getDefaultState = () => ({
});

export const state = getDefaultState();

export const getters = {};

export const mutations = {};

export const actions = {
  async fetchCompany() {
    const token = await auth.currentUser.getIdToken();

    try {
      const response = await api.get(
        '/companies',
        { headers: { Authorization: `Bearer ${token}` } },
      );

      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  async save(_, { payload }) {
    try {
      const token = await auth.currentUser.getIdToken();

      await api.put(
        '/companies',
        payload,
        { headers: { Authorization: `Bearer ${token}` } },
      );
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  async saveValidation(_, { payload }) {
    const token = await auth.currentUser.getIdToken();

    try {
      const formData = new FormData();
      
      if (payload.files && payload.files.length > 0) {
        const filenames = {};
        
        payload.files.forEach((file) => {
          formData.append('files', file);
          filenames[file.name] = file.name;
        });
        
        formData.append('filenames', JSON.stringify(filenames));
      }
      
      formData.append('notes', payload.notes);
      formData.append('deletedFiles', JSON.stringify(payload.deletedFiles));

      await api.post(
        '/companies/validation',
        formData,
        { 
          headers: { 
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
          } 
        },
      );
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  async fetchValidation() {
    const token = await auth.currentUser.getIdToken();

    try {
      const response = await api.get(
        '/companies/validation',
        { headers: { Authorization: `Bearer ${token}` } },
      );

      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}; 